import { Navigate, Outlet } from 'react-router-dom';
import { useAccountStore } from '@/store/account.store';
import { PageLoader } from './PageLoader';

/**
 * ProtectedAdminRoute — assumes the caller is already inside a ProtectedRoute
 * (so the account is loaded). If the user isn't an admin we redirect to
 * /library per ADMIN_DASHBOARD.md.
 *
 * Role is read off `AccountStore.account.isAdmin`, which the server stamps
 * onto every `/accounts/me` and `/auth/callback` payload via the
 * `get_user_role` RPC. The server-side `AdminGuard` independently enforces
 * the same check on every write, so this gate is purely UX — a client
 * that tampers with the flag still can't mutate admin-only resources.
 */
export function ProtectedAdminRoute() {
  const account = useAccountStore((s) => s.account);
  const isAdmin = useAccountStore((s) => s.isAdmin());

  if (!account) return <PageLoader label="Checking permissions…" />;
  if (!isAdmin) return <Navigate to="/library" replace />;
  return <Outlet />;
}
